import Image from '@material-ui/icons/Image';
import Videocam from '@material-ui/icons/Videocam';
import { createElement, FC } from 'react';

import { CreativeFormatCreativeType } from '../../../generated/graphql';

type Props = {
  creativeType: Pick<CreativeFormatCreativeType, 'key' | 'name'>;
  size?: number;
  color?: string;
  className?: string;
};

const CreativeFormatCreativeTypeIcon: FC<Props> = ({ creativeType, size, color, className }) => {
  if (creativeType.key === 'video') {
    return <Videocam className={className} style={{ width: size, height: size, color: color || '#414a5d' }} />;
  }
  if (creativeType.key === 'static_image') {
    return <Image className={className} style={{ width: size, height: size, color: color || '#fcb100' }} />;
  }
  return <div>{creativeType.name}</div>;
};

export default CreativeFormatCreativeTypeIcon;
